<template>
  <div class="milestone">
    <div class="progress-node-container">
      <div class="progress-btn-container">
        <a-button v-if="canManageProgress && progressNode.current && progressNode.status!=='COMPLETED'" size="small" type="primary" @click="makeProgress" class="update-progress-btn">{{ nextPaymentNodeStatusName }}</a-button>
        <a-button v-if="canManageProgress && canEscape(progressNode)" @click="escapePayment" size="small" style="margin-left: 4px">跳过</a-button>
      </div>
      <div class="progress-name-container">
        <img :src="findNodeStatusImg(progressNode.status)" class="progress-icon">
        <span class="milestone-name">{{progressNode.name}}</span>
      </div>
      <div class="progress-log-container">
        <div v-for="progressLog in progressNode.logList" :key="progressLog.logId" class="progress-log">
          {{progressLog.logTime}}  {{ progressLog.nodeStatusName }}
        </div>
      </div>
      <div class="attachment-container">
        <a-upload
            v-if="canManageProgress"
            name="file"
            :multiple="false"
            :action="uploadUrl"
            :headers="headers"
            :file-list="progressNode.docList"
            @preview="previewFile"
            @change="onPrepayDocUploaded"
        >
          <a-button> <a-icon type="upload" /> 点击上传 </a-button>
        </a-upload>
        <p v-for="doc in progressNode.docList" :key="doc.uid">
          <a @click="onDownload(doc)" class="download-btn"><a-icon type="download" /> {{ doc.name }} </a>
          <a v-if="!canManageProgress" @click="previewFile(doc)"><a-icon type="eye" /> 预览 </a>
        </p>
      </div>
    </div>
    <div v-if="progressNode.code!=='REQUEST_WARRANTY_PAYMENT'" class="horizontal-line"></div>
  </div>
</template>
<script>
import {updateProgressDocs} from "@/views/progress/ProgressApi";
import {baseURL} from "@/services/HttpService";

export default {
  props: {
    projectId: {
      type: String,
      required: true
    },
    canManageProgress: {
      type: Boolean,
      default: false
    },
    progressNode: {
      type: Object,
      required: true
    },
    nextPaymentNodeStatusName: {
      type: String,
      default: "发起"
    }
  },
  emits: ['makePaymentProgress', 'escapePaymentProgress', 'previewDoc', 'downloadDoc'],
  data() {
    return {
      uploadUrl: `${baseURL}/upload/progress`,
      headers: {
        Authorization: localStorage.getItem("token")
      },
    };
  },
  methods: {
    makeProgress() {
      this.$emit("makePaymentProgress", this.progressNode.code);
    },
    escapePayment() {
      this.$emit("escapePaymentProgress", this.progressNode.code);
    },
    previewFile(doc) {
      this.$emit("previewDoc", doc);
    },
    onDownload(doc){
      this.$emit("downloadDoc", doc);
    },
    canEscape(progressNode) {
      return progressNode.current && progressNode.status==='NOT_STARTED' && (progressNode.code ==='PREPAY' || progressNode.code ==='GRID_CONNECTION_PAYMENT');
    },
    findNodeStatusImg(progressNodeStatus) {
      if (progressNodeStatus === "NOT_STARTED") {
        return require("@/assets/icon-not-start.png");
      } else if (progressNodeStatus === "INITIATED") {
        return require("@/assets/icon-started.png");
      } else if (progressNodeStatus === "COMPLETED") {
        return require("@/assets/icon-completed.png");
      } else if (progressNodeStatus === "SKIPPED") {
        return require("@/assets/icon-skipped.png");
      } else {
        return require("@/assets/icon-in-progress.png");
      }
    },
    onPrepayDocUploaded(info){
      console.log('预付款附件上传状态', info.file.status);
      let fileList = [...info.fileList];

      fileList = fileList.map(file => {
        if (file.response) {
          file.url = this.viewUrl + file.response.data;
        }
        return file;
      });
      this.progressNode.docList = fileList;
      if(info.file.status === 'done' || info.file.status === 'removed') {
        this.saveAttachment(fileList, this.progressNode.code);
      }
    },
    saveAttachment(fileList, nodeCode) {
      let docList = [];
      for(let i=0; i<fileList.length; i++){
        let oneDoc = fileList[i];
        if(oneDoc.url) {
          docList.push({
            uid: oneDoc.uid,
            name: oneDoc.name,
            url: oneDoc.url.replace(this.viewUrl, '')
          });
        }
      }
      let params = {
        projectId: this.projectId,
        progressNodeCode: nodeCode,
        docList: docList
      }
      console.log('params', params);
      updateProgressDocs(params).then(response => {
        if (response.data.code === "SUCCESS") {
          console.log("附件操作成功");
        } else {
          this.$message.error("附件保存失败");
        }
      });
    },
  }
}
</script>
<style scoped>
.milestone {
  display: flex;
  align-items: flex-start;
}
.progress-btn-container{
  height: 30px;
}
.progress-name-container {
  white-space: nowrap;
}
.progress-log-container {
  min-height: 30px;
  padding: 6px 0;
  font-size: 12px;
  color: #999999;
}
.progress-log {
  white-space: nowrap;
}
.progress-icon {
  color: green;
}
.milestone-name {
  vertical-align: middle;
  padding-left: 6px;
  white-space: nowrap;
}
.horizontal-line {
  border-bottom: 1px solid black;
  width: 50px;
  height: 2px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 40px;
}
.update-progress-btn {
  margin-left: 10px;
}
.download-btn {
  margin-right: 30px;
}
</style>
